import { render } from "./CompareRewardsBanner.vue?vue&type=template&id=9f76c018"
import script from "./CompareRewardsBanner.vue?vue&type=script&lang=js"
export * from "./CompareRewardsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__